export const baseAPIGenerationUrl = `${process.env.REACT_APP_BASE_URL}/gen`;
export const baseAPIUrl = `${process.env.REACT_APP_BASE_URL}/api`;
export const baseUrl = `${process.env.REACT_APP_BASE_URL}/app`;
